import Vue from 'vue';

import VeeValidate, { Validator } from 'vee-validate';
import DataTable from "@andresouzaabreu/vue-data-table";
import "@andresouzaabreu/vue-data-table/dist/DataTable.css";
Vue.component("data-table", DataTable);
// Add locale helper.
import { dict } from './config/lang/es/dict.js'
Validator.updateDictionary(dict);
import es from 'vee-validate/dist/locale/es';

import VueHighcharts from 'vue-highcharts';

Vue.use(VueHighcharts);

Validator.addLocale(es);
const config = {
    errorBagName: '_errors', // change if property conflicts.
    locale: 'es'
};
Vue.use(VeeValidate, config);
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
// baseURL
//var baseURL = 'https://api.agendaenlinea.cl/api/'
var baseURL = 'https://api.agendaenlinea.cl/api/'

// baseURL - Global
// var urlGlobal = 'https://globales.agendaenlinea.cl/'
var urlGlobal = 'https://globales.agendaenlinea.cl/'

import { env } from './config/env.js'
if (!process.env.NODE_ENV) process.env.NODE_ENV = JSON.parse(config.dev.env.NODE_ENV)
/*
if (process.env.NODE_ENV == 'development') {
  baseURL = env.baseURL;
  urlGlobal = env.urlGlobal
}
*/

/** AGREGADO POR MAURICIO MARCHANT PARA ESTABLECER 3 AMBIENTES, LOCAL-DESARROLLO Y PRODUCCIÓN INDEPENDIENTE SI LA APP ESTÁ EN MODO PRODUCTION O DELVELOPMENT*/

switch(env.enviroment){
    default: 
        baseURL = env.baseURL;
        urlGlobal = env.urlGlobal;
    break;
    case 'local':
        baseURL = env.LOCALbaseURL;
        urlGlobal = env.LOCALurlGlobal;
    break;
    case 'development':
        baseURL = env.DEVbaseURL;
        urlGlobal = env.DEVurlGlobal;
    break;
}




// Google maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAezzmwzFNOztBaNVvUPB0NVI9LDpFoC80',
    }
})

// Graficas / Chartjs
// import VueCharts from 'vue-chartjs'
// Vue.use(VueCharts);
// Axios
import axios from 'axios';
import VueAxios from 'vue-axios';
var instance_axios = axios.create({
    baseURL: baseURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});
Vue.use(VueAxios, instance_axios);

// Authenticate
import Auth from './packages/auth/Auth.js';
Vue.use(Auth);

// Language
import Lang from './packages/lang/Lang.js';
Vue.use(Lang);

// Router
import Router from './router';
// Prefix
import { prefix } from './config/api';

// Config Router
Router.beforeEach(
    (to, from, next) => {
        if (prefix.indexOf(to.params.country) < 0) {
            // Update title
            document.title = 'AMOL - ' + to.meta.name;
            next({
                path: '/'
            });
        }
        if (to.matched.some(record => record.meta.forVisitors)) {
            if (Vue.auth.isAuthenticated()) {
                // Update title
                document.title = 'AMOL - ' + to.meta.name;
                // Redirect office by default
                next({
                    path: '/' + to.params.country + '/dashboard'
                });
            } else {
                // Update title
                document.title = 'AMOL - ' + to.meta.name;
                next();
            }
        } else {
            // Update title
            document.title = 'AMOL - ' + to.meta.name;
            next();
        }
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!Vue.auth.isAuthenticated()) {
                // Update title
                document.title = 'AMOL - ' + to.meta.name;
                // Redirect login
                next({
                    path: '/' + to.params.country
                });
            } else {
                document.title = 'AMOL - ' + to.meta.name;
                next();
            }
        }
    }
);

// Vue Material
import VueMaterial from 'vue-material';
Vue.use(VueMaterial);

// FBSignInButton
import FBSignInButton from 'vue-facebook-signin-button';
Vue.use(FBSignInButton);

// Setup theme vue material
Vue.material.registerTheme({
    default: {
        primary: {
            color: 'cyan',
            hue: 600,
            textColor: 'white'
        },
        accent: {
            color: 'cyan',
            hue: 600,
            textColor: 'white'
        },
        warn: {
            color: 'red',
            hue: 400
        }
    },
    green: {
        primary: {
            color: 'light-green',
            textColor: 'white',
            hue: 500
        },
        accent: {
            color: 'blue',
            textColor: 'white',
            hue: 500
        },
        warn: {
            color: 'red',
            hue: 400
        }
    }
})

// Applied Format enabled
Vue.filter('formatEnabled', function(value) {
    return (value) ? 'Disponible' : 'Desactivado';
});

import 'vue-orgchart/dist/style.min.css'

// Applied Format Status
import formatStatus from './filters/formatStatus';
Vue.filter('formatStatus', formatStatus);

// Applied Format Day
import formatDay from './filters/formatDay';
Vue.filter('formatDay', formatDay);

// Applied Format Days
import formatDays from './filters/formatDays';
Vue.filter('formatDays', formatDays);

// Applied Format Turn
import formatTurn from './filters/formatTurn';
Vue.filter('formatTurn', formatTurn);

// Applied Format Percentage
import formatPercentage from './filters/formatPercentage';
Vue.filter('formatPercentage', formatPercentage);

// Applied Format Date
import {formatDate,formatDateToHTML5, formatDateHour} from './filters/formatDate';
Vue.filter('formatDate', formatDate);

Vue.filter('formatDateHour', formatDateHour);

Vue.filter('formatDateToHTML5', formatDateToHTML5);
// Applied Format Timestamp
import formatTimeStamp from './filters/formatTimeStamp';
Vue.filter('formatTimeStamp', formatTimeStamp);

// Applied Format FullName
import formatFullName from './filters/formatFullName'
Vue.filter('formatFullName', formatFullName)

Vue.config.productionTip = false;

import App from './App';
import store from './store';

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router: Router,
    template: '<App/>',
    components: {
        App
    }
});



// WEBPACK FOOTER //
// ./src/main.js